import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Header } from '../components/header';
import { InspectionQuestionnaire } from '../components/inspection-questionnaire';
import { useLanguage } from '../context/language-context';
import { ArrowLeft, User, List, AlignJustify } from 'lucide-react';
import { Button } from '../components/ui/button';

const InspectionQuestionnairePage = () => {
  const { id } = useParams<{ id: string }>();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [quickMode, setQuickMode] = useState(false);

  const handleClose = () => {
    navigate(`/establishment/${id}`);
  };

  const handleSubmit = (data: any) => {
    console.log('Inspection data submitted:', data);
    navigate(`/establishment/${id}`);
  };

  const toggleQuickMode = () => {
    setQuickMode(!quickMode);
  };

  return (
    <div
      className="flex flex-col"
      dir={language === 'ar' ? 'rtl' : 'ltr'}
    >
      {/* <Header
        title={
          language === 'en'
            ? 'Inspection Questionnaire'
            : 'استبيان التفتيش'
        }
        isRTL={language === 'ar'}
        showBackButton={true}
        backTo={`/establishment/${id}`}
      /> */}

      {/* Quick Mode Toggle */}
      {/* <div className="bg-white p-2 flex justify-end border-b hidden">
        <div className="flex items-center bg-gray-100 p-1 rounded-full">
          <Button
            onClick={toggleQuickMode}
            className={`px-3 py-1 rounded-full flex items-center gap-1 ${
              !quickMode
                ? 'bg-[#b89256] text-white'
                : 'bg-transparent text-gray-600'
            }`}
            variant="ghost"
          >
            <AlignJustify className="h-4 w-4" />
            <span className="text-xs">
              {language === 'en' ? 'Standard' : 'قياسي'}
            </span>
          </Button>
          <Button
            onClick={toggleQuickMode}
            className={`px-3 py-1 rounded-full flex items-center gap-1 ${
              quickMode
                ? 'bg-[#b89256] text-white'
                : 'bg-transparent text-gray-600'
            }`}
            variant="ghost"
          >
            <List className="h-4 w-4" />
            <span className="text-xs">
              {language === 'en' ? 'Quick Mode' : 'الوضع السريع'}
            </span>
          </Button>
        </div>
      </div> */}

      <div className="flex-1 overflow-auto border border-gray-200 rounded-lg shadow-lg">
        <InspectionQuestionnaire
          onClose={handleClose}
          onSubmit={handleSubmit}
          language={language}
          taskDetails={{ id }}
          quickMode={quickMode}
        />
      </div>
    </div>
  );
};

export default InspectionQuestionnairePage;
